import React from "react";
import { NavLink } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
// React bootstrap components
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";

// Materialui components
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DeleteIcon from '@mui/icons-material/Delete';

// Types and constants
import { UserContext } from "../../context/UserContext";
import { loginRequest, } from "../../authConfig";

const NavigationBar = () => {
    const user = React.useContext(UserContext).user;

    const { instance } = useMsal();
    const pages = ['Firmware', 'Tune', 'Options', 'Users'];

    return (

        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" data-testid='navigation-bar-container'>
            <Container>

                <Navbar.Brand>FOX CMS</Navbar.Brand>

                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">

                    <AuthenticatedTemplate>
                        <Nav className="me-auto">
                            {
                                pages.map((page) => (
                                    <Nav.Link as={NavLink} to={`/${page.toLowerCase()}`} key={page}>{page}</Nav.Link>
                                ))
                            }
                        </Nav>
                        <Nav>
                            {
                                user.name ?
                                    (
                                        <NavDropdown title={`${user.name}`} id="collasible-nav-dropdown">
                                            <NavDropdown.Divider />
                                            <NavDropdown.Item onClick={() => instance.logoutRedirect()}>Log out</NavDropdown.Item>
                                        </NavDropdown>
                                    ) : <AccountCircleIcon sx={{ color: 'white' }} />
                            }
                            <DeleteIcon />
                        </Nav>
                    </AuthenticatedTemplate>

                    <UnauthenticatedTemplate>
                        <Nav className="ms-auto">
                            <Nav.Link href="#" onClick={() => instance.loginRedirect(loginRequest)}> Sign In / Sign Up </Nav.Link>
                        </Nav>
                    </UnauthenticatedTemplate>

                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavigationBar;